import React from 'react';

import { FormBase } from '../Interface';
import { usePlanTask } from '../../hooks/usePlanTask';
import { PlanTaskPage } from './PlanTaskPage';
import PlanTaskReports from './PlanTaskReports';

export const PlanTaskMain = () => {
  const planTaskState = usePlanTask();

  return (
    <FormBase
      name="PlanTask"
      leftPanelContent={<PlanTaskPage planTaskState={planTaskState} />}
      rightPanelContent={!planTaskState.loading && <PlanTaskReports planTaskState={planTaskState} />}
    ></FormBase>
  );
};
